<div class="accordion-header" role="tab" *ngIf="heading" (click)="toggleOpen($event)">
  <h3 class="mb-0">
    <button class="accordion-button" [ngClass]="{'text-muted': disabled, 'collapsed': !isOpen}" [attr.aria-expanded]="isOpen" aria-controls="pmd-collapseOne">
        {{ heading }} 
    </button>
    <ng-content select="[pmd-accordion-heading]"></ng-content>
  </h3>
</div>
<ng-content select="pmd-accordion-item-header"></ng-content>
<div class="accordion-collapse collapse" role="tabpanel" [pmdCollapse]="!isOpen">
  <div class="accordion-body">
      <ng-content></ng-content>
  </div>
</div>
    